export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11844.2cfc1414.jpg";